
import React from 'react';
import { ImageUploader as UploadComponent } from './upload';
import { ImageUploaderProps } from './upload/types';

const ImageUploader: React.FC<ImageUploaderProps> = (props) => {
  return <UploadComponent {...props} />;
};

export default ImageUploader;
export type { ImageUploaderProps } from './upload/types';
